import { Controller } from "@hotwired/stimulus"

// This controller is used to move a dropdown content to a specific HTML element.
// It's useful when the initial parent has an overflow: hidden which can impact the visibility of the dropdown content.
// It should be used in association with the dropdown-menu--fixed class.
export default class extends Controller {
  static get targets()  {
    return ["trigger", "menu"]
  }

  static values = { container: String }

  connect() {
    const initialParent = this.element
    const dropdown = this.triggerTarget
    const menu = this.menuTarget
    const newParent = document.querySelector(this.containerValue)

    // On show move the menu to the new container
    dropdown.addEventListener('show.bs.dropdown', () => {
      newParent.appendChild(menu)
    })

    // On hide move it back to his initial parent
    dropdown.addEventListener('hidden.bs.dropdown', () => {
      initialParent.appendChild(menu)
    })
  }
}
